import { dateFormatter } from 'sfy-react'

export const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

/**
 * Returns the currency in locale format
 * @param {String} locale locale string e.g 'en-IN' or 'de-DE' or 'tr-TR'
 * @param {String} currencyCode Code of the required currency e.g 'INR' or 'EUR' or 'TRY'
 * @param {Number} amount value which needs to be formatted
 * @returns {String} locale currency value
 */
export const getLocaleCurrency = (locale = 'en-IN', currencyCode = 'INR', amount = 0) => {
  let floatAmount = parseFloat(amount)
  let options = {
    style: 'currency',
    currency: currencyCode,
  }
  return new Intl.NumberFormat(locale, options).format(floatAmount)
}

/**
 * Returns date in locale format
 * @param {String} format required format'
 * @param {Date | String} date date which needs to be formatted. can be Date object or iso string.
 * @returns {String} locale date string
 */

export const getLocaleDate = (format = 'DD/MM/YYYY', date) => {
  return dateFormatter(date ? new Date(date) : new Date(), format.toLowerCase())
}

/**
 * Receives a time string eg: '18:00:00' and returns it's locale e.g '6:00 AM'
 * @param {String} timeString time string eg: '18:00:00'
 * @param {String} locale locale string eg: 'en-IN'
 * @returns formatted locale time
 */
export const getFormattedTime = (timeString = '', locale = 'en', options = {}) => {
  let d = new Date()
  let timeArr = timeString.split(':').map((timeComponent) => parseInt(timeComponent))
  d.setHours(timeArr[0])
  d.setMinutes(timeArr[1])
  d.setSeconds(timeArr[2])
  return getLocaleTime(d, locale, options)
}

/**
 * Returns time string in locale format
 * @param {Date} time the date object to be foramtted
 * @param {String} locale locale string e.g 'en-IN' or 'de-DE' or 'tr-TR'
 * @param {Object} options extra information for formatting refer @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleTimeString}
 */
export const getLocaleTime = (time, locale = 'en-IN', options = {}) => {
  return time.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', ...options })
}

export const getFormattedDate = (
  date,
  locale = 'en-GB',
  options = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }
) => `${new Date(date).toLocaleDateString(locale, options)}`
